import { Box, List, Text } from '@chakra-ui/react'
import type { PublicJoinResponse } from '@ipc/shared'
import { Rich, useT } from '~/i18n/use-t'

/**
 * The two legal-floor lines the consent refers to ("as explained above"), unfolded (R0): no video is kept, and the
 * face template. The review photos are named in the consent itself and explained in the FAQ (`faceData`), so the
 * phone screen stays within its scrolling budget. What the provider does with the pictures, and how to delete, is in the FAQ (`faceData`).
 * A test provider (`test_provider_keeps`, copy v8, E12.9) keeps its own unfolded points exactly as before.
 */
export function FaceNotice({ notice, provider }: { notice: PublicJoinResponse['faceNotice']; provider: string }) {
  const { t } = useT()
  if (notice !== 'test_provider_keeps')
    // Two sentences, two paragraphs, but they run on as one block: no gap and no half-empty line between them.
    return (
      <Box>
        <Text display='inline'>
          <Rich k='aboutFace.generic' />
        </Text>{' '}
        <Text display='inline'>
          <Rich k='aboutFace.template' />
        </Text>
      </Box>
    )
  return (
    <List.Root ps={6} gap={2}>
      <List.Item>
        <Rich k='testProvider.aboutFace1' values={{ provider }} />
      </List.Item>
      <List.Item>
        <Rich k='testProvider.aboutFace2' values={{ provider }} />
      </List.Item>
      <List.Item>
        <Rich k='aboutFace.template' />
      </List.Item>
      <List.Item>{t('aboutFace.delete')}</List.Item>
    </List.Root>
  )
}
